<template>
    <div>

<!--hero section start-->

<section class="banner pos-r fullscreen-banner dark-bg o-hidden">
  <div class="align-center pt-0 b-pl">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-5">
          <div class="bnr-title large">P.</div>
        </div>
        <div class="col-md-7">
          <h1 class="text-white">Welcome to creative
design portfolio</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="hero-left h-100 d-flex align-items-center justify-content-center">
    <div class="hero-social text-center">
      <ul class="list-unstyled">
        <li>
          <a href="#"> <i class="fab fa-facebook-f"></i>
          </a>
        </li>
        <li>
          <a href="#"> <i class="fab fa-dribbble"></i>
          </a>
        </li>
        <li>
          <a href="#"> <i class="fab fa-skype"></i>
          </a>
        </li>
        <li>
          <a href="#"> <i class="fab fa-linkedin-in"></i>
          </a>
        </li>
      </ul>
    </div> <a href="#main-page" class="scroll-down-arrow"></a>
  </div>
  <div class="inside-text"> <span>Agencio</span>
  </div>
  <div class="ripple-background">
    <div class="circle shade1"></div>
    <div class="circle shade2"></div>
    <div class="circle shade3"></div>
    <div class="circle shade4"></div>
    <div class="circle shade5"></div>
  </div>
</section>

<!--hero section end-->
<!--body content start-->

<div id="main-page" class="page-content">

<section class="theme-bg p-0" data-bg-img="images/pattern/01.png">
  <div class="container">
    <div class="row custom-mt-10">
      <div class="col-lg-12 col-md-12">
        <div class="masonry row popup-gallery no-gutters">
          <div class="grid-sizer"></div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/01.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/01.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Creative Design</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/02.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Ui</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/03.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/03.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Design Mockup</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/04.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/04.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Screen</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/07.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Creative Cake</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/05.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/05.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Social Media</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/06.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/06.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Development</a></h5>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter start-->

<section class="theme-bg">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
            </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
          </div>
          <h6>Lot's Of Work Completed</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-sm-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-experience"></i>
            </div> <span class="count-number" data-to="20" data-speed="4000">20</span>
          </div>
          <h6>Years of Experience</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
            </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
          </div>
          <h6>Best Awards Winning</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-rating"></i>
            </div> <span class="count-number" data-to="950" data-speed="4000">950</span>
          </div>
          <h6>Reviews from clients</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter end-->

</div>

<!--body content end--> 
    </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "home",
        }
    }
};
</script>